import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // return next(req);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const cookieService = inject(SsrCookieService);
  const request = shouldAttachServerCookies(req.url, platformId)
    ? req.clone({
        setHeaders: {
          cookie: buildCookieHeader(cookieService),
        },
      })
    : req;

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        isPlatformBrowser(platformId) &&
        error.status === 401 &&
        !req.url.startsWith(environment.aiCoreUrl)
      ) {
        if (!router.url.includes('/login')) {
          // console.log('Sesión expirada, redirigiendo al login...');
          router.navigate(['/login']);
        }
      }

      return throwError(() => error);
    }),
  );
};

function shouldAttachServerCookies(url: string, platformId: object): boolean {
  return isPlatformServer(platformId) && url.startsWith(environment.apiHost);
}

function buildCookieHeader(cookieService: SsrCookieService): string {
  return Object.entries(cookieService.getAll())
    .map(([key, value]) => `${key}=${value}`)
    .join('; ');
}
